import React from 'react'
import ReactDOM from 'react-dom'

import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';

import store from './Store';
import './App.css';
import './component/style/documentTransform.css'
import logo from './KAVIR-RGB.png';
import image from './Sarbarg-Motorcycle-Design.jpg';
import Login from './component/authentication/Login';
import Register from './component/authentication/Register';



// import Register from './component/dashboard/Register';
import Dashboard from './component/dashboard/Dashboard';
import Home from './component/dashboard/Home';
import Document from './component/dashboard/Document';
import DocumentEdit from './component/dashboard/DocumentEdit';
import DocumentIndex from './component/dashboard/DocumentIndex';
import DocumentRequest from './component/dashboard/DocumentRequest';
import DocumentRequestIndex from './component/dashboard/DocumentReqestIndex';
import DocumentStatus from './component/dashboard/DocumentStatus';
import Archive from './component/dashboard/Archive';
import ArchiveIndex from './component/dashboard/ArchiveIndex';
import Appointment from './component/Appointment';
import Appointments from './component/dashboard/Appointments';
import ArchiveSectionOne from './component/dashboard/ArchiveSectionOne';
import ArchiveSectionTwo from './component/dashboard/ArchiveSectionTwo';
import ArchiveSectionThree from './component/dashboard/ArchiveSectionThree';
import ArchiveSectionOneIndex from './component/dashboard/ArchiveSectionOneIndex';
import ArchiveSectionTwoIndex from './component/dashboard/ArchiveSectionTwoIndex';
import ArchiveSectionThreeIndex from './component/dashboard/ArchiveSectionThreeIndex';
import DocumentLog from './component/dashboard/DocumentLog';
import DocumentTransfer from './component/dashboard/DocumentTransfer';
import DocumentTransferIndex from './component/dashboard/DocumentTransferIndex';
import Permission from './component/dashboard/Permission';
import UserIndex from './component/dashboard/UserIndex';
import ArchiveManagment from './component/dashboard/ArchiveManagment';
import StatusManagment from './component/dashboard/StatusManagment';
import DocumentManagment from './component/dashboard/DocumentManagment';
import DocumentFiscal from './component/dashboard/DocumentFiscal';
import UserManagment from './component/dashboard/UserManagment';

import DocumentTransferUploadFile from './component/dashboard/DocumentTransferUploadFile';
import Customers from './component/dashboard/Customers';
import CustomerImport from './component/dashboard/CustomerImport';
import Factors from './component/dashboard/Factors';
import FactorImport from './component/dashboard/FactorImport';
import DocumentPrint from './component/dashboard/DocumentPrint'
import DocumentAgentRequest from './component/dashboard/DocumentAgentRequest'

// agent  component
import CreateAgent from  './component/dashboard/CreateAgent';
import EditAgent from './component/dashboard/EditAgent';
import ListAgents from './component/dashboard/ListAgents';
import RequestAgents from './component/dashboard/RequrstAgents';
import Agent from './component/agent/Agent';
import AgentLogin from './component/agent/Login/Login';
import AgentHome from './component/agent/Home';
import AgentRequestCreate from './component/agent/request/Create'
import AgentRequestIndex from './component/agent/request/Index'
import AgentRequestEdit from './component/agent/request/Edit';

import AgentPlansIndex from './component/agent/Plans'
import AgentPaymentVerify from './component/agent/PaymentVerify'


// exhibition  component
import CreateExhibition from  './component/dashboard/CreateExhibition';
import EditExhibitions from './component/dashboard/EditExhibitions';
import ListExhibitions from './component/dashboard/ListExhibitions';
import RequestExhibitions from './component/dashboard/RequrstExhibitions';
import Exhibition from './component/exhibition/Exhibition';
import ExhibitionLogin from './component/exhibition/Login/Login';
import ExhibitionHome from './component/exhibition/Home';
import ExhibitionRequestCreate from './component/exhibition/request/Create'
import ExhibitionRequestIndex from './component/exhibition/request/Index'
import ExhibitionRequestEdit from './component/exhibition/request/Edit';
import ExhibitionArchiveIndex from './component/exhibition/store/ExhibitionArchiveIndex';
import ExhibitionArchiveSectionOneIndex from './component/exhibition/store/ExhibitionArchiveSectionOneIndex';
import ExhibitionArchiveSectionTwoIndex from './component/exhibition/store/ExhibitionArchiveSectionTwoIndex';
import ExhibitionArchiveSectionThreeIndex from './component/exhibition/store/ExhibitionArchiveSectionThreeIndex';

function App() {
  const apiUrl = 'http://localhost:8000/api/v1/'
  return (
    <Provider store={store}>
      <BrowserRouter>
          <Routes>
            <Route exact path="/" element={<Login logo={logo} />} />
            <Route exact path="/login" element={<Login logo={logo} />} />
            <Route exact path="/agent/login" element={<AgentLogin logo={logo} />} />
            <Route exact path="/exhibition/login" element={<ExhibitionLogin logo={logo} />} />
            {/* dashboard */}
            <Route exact path="/appointment" element={<Appointment logo={logo} />} />
            <Route exact path="/dashboard" element={<Dashboard logo={''} />} >
              <Route exact path="/dashboard" index element={<Home />} />
              <Route exact path="/dashboard/user/register" element={<Register logo={logo} />} />
              <Route exact path="/dashboard/document/create" element={<Document />} />
              <Route exact path="/dashboard/documents" element={<DocumentIndex />} />
              <Route exact path="/dashboard/document/edit/:id" element={<DocumentEdit />} />
              <Route exact path="/dashboard/document/request/create" element={<DocumentRequest />} />
              <Route exact path="/dashboard/document/requests" element={<DocumentRequestIndex />} />
              <Route exact path="/dashboard/document/status" element={<DocumentStatus />} />
              <Route exact path="/dashboard/archive/create" element={<Archive />} />
              <Route exact path="/dashboard/archive/index" element={<ArchiveIndex />} />
              <Route exact path="/dashboard/appointments" element={<Appointments />} />
              <Route exact path="/dashboard/archive/section/one" element={<ArchiveSectionOne />} />
              <Route exact path="/dashboard/archive/section/two" element={<ArchiveSectionTwo />} />
              <Route exact path="/dashboard/archive/section/three" element={<ArchiveSectionThree />} />
              <Route exact path="/dashboard/archive/section/one/index/:section" element={<ArchiveSectionOneIndex />} />
              <Route exact path="/dashboard/archive/section/two/index/:section" element={<ArchiveSectionTwoIndex />} />
              <Route exact path="/dashboard/archive/section/three/index/:section" element={<ArchiveSectionThreeIndex />} />
              <Route exact path="/dashboard/documentLog/search" element={<DocumentLog />} />
              <Route exact path="/dashboard/document/transfer"  element={<DocumentTransfer />} />
              <Route exact path="/dashboard/document/transfers/:document"  element={<DocumentTransferIndex />} />
              <Route exact path="/dashboard/document/:document/transfer/:transfer" element={<DocumentTransferUploadFile />} />
              <Route exact path="/dashboard/document/print/:id" element={<DocumentPrint />} />
              <Route exact path="/dashboard/document/permission/:id" element={<DocumentManagment />} />
              <Route exact path="/dashboard/document/fiscal/:id" element={<DocumentFiscal />} />
              <Route exact path="/dashboard/permission/:id" element={<Permission />} />
              <Route exact path="/dashboard/permission" element={<Permission />} />
              <Route exact path="/dashboard/user/index" element={<UserIndex />} />
              <Route exact path="/dashboard/archive/permission/:id" element={<ArchiveManagment />} />
              <Route exact path="/dashboard/status/permission/:id" element={<StatusManagment />} />
              <Route exact path="/dashboard/edit/user/:id" element={<UserManagment />} />
              <Route exact path="/dashboard/customers" element={<Customers />} />
              <Route exact path="/dashboard/customer/upload" element={<CustomerImport />} />
              <Route exact path="/dashboard/factors" element={<Factors />} />
              <Route exact path="/dashboard/factor/upload" element={<FactorImport />} />
              <Route exact path="/dashboard/document/agent/request" element={<DocumentAgentRequest />} />
              <Route exact path="/dashboard/agent/create" element={<CreateAgent/>} />
              <Route exact path="/dashboard/agents" element={<ListAgents />} />
              <Route exact path="/dashboard/agent/requests" element={<RequestAgents />} />
              <Route exact path="/dashboard/exhibition/create" element={<CreateExhibition/>} />
              <Route exact path="/dashboard/exhibitions" element={<ListExhibitions />} />
              <Route exact path="/dashboard/exhibition/requests" element={<RequestExhibitions />} />
              <Route exact path="/dashboard/exhibition/edit/:id" element={<EditExhibitions />} />
              <Route exact path="/dashboard/edit/agent/:id" element={<EditAgent />} />
            </Route>
            {/* agent */}
            <Route exact path="/agent" element={<Agent logo={logo} />} >
              <Route exact path="/agent" index element={<AgentHome />} />
              <Route exact path="/agent/request/create" element={<AgentRequestCreate />} />
              <Route exact path="/agent/request/edit/:id" element={<AgentRequestEdit/>} />
              <Route exact path="/agent/requests" element={<AgentRequestIndex />} />
              <Route exact path="/agent/plans" element={<AgentPlansIndex />} />
              <Route exact path="/agent/plans/payment/verify" element={<AgentPaymentVerify />} />
              
            </Route>
            {/* exhibition */}
            <Route exact path="/exhibition" element={<Exhibition logo={logo} />} >
              <Route exact path="/exhibition" index element={<ExhibitionHome />} />
              <Route exact path="/exhibition/request/create" element={<ExhibitionRequestCreate />} />
              <Route exact path="/exhibition/request/edit/:id" element={<ExhibitionRequestEdit/>} />
              <Route exact path="/exhibition/requests" element={<ExhibitionRequestIndex />} />
              <Route exact path="/exhibition/archive/index" element={<ExhibitionArchiveIndex />} />
              <Route exact path="/exhibition/store/section/one/:section" element={<ExhibitionArchiveSectionOneIndex />} />
              <Route exact path="/exhibition/store/section/two/:section" element={<ExhibitionArchiveSectionTwoIndex />} />
              <Route exact path="/exhibition/store/section/three/:section" element={<ExhibitionArchiveSectionThreeIndex />} />
            </Route>
          </Routes>  
      </BrowserRouter>
    </Provider>  
  );
}

export default App;
